import React from 'react';
import { MirrorBadge } from './mirror-badge.component';
import { buildMirrorTooltip } from './build-mirror-tooltip';
import { buildMirroredInTooltip } from './build-mirrored-in-tooltip';

export function CategoryMirrorBadge({
  adminMode,
  isCollaboratorUser,
  mirroredFrom,
  mirroredFromInfo,
  mirroredInTargets,
  mirrorLang,
  className,
  iconClassName,
}) {
  if (!adminMode || !isCollaboratorUser) return null;
  if (mirroredFrom) {
    return (
      <MirrorBadge
        label={buildMirrorTooltip(mirroredFromInfo, mirrorLang)}
        className={className}
        iconClassName={iconClassName}
      />
    );
  }
  if (mirroredInTargets.length > 0) {
    return (
      <MirrorBadge
        variant="source"
        label={buildMirroredInTooltip(mirroredInTargets, mirrorLang)}
        className={className}
      />
    );
  }
  return null;
}
